import io from 'socket.io-client';

declare const process: {
  env: Record<string, string | undefined>;
};

const socketUrl = process.env.REACT_APP_SOCKET_API || process.env.REACT_APP_ESTIMATES_API || globalThis.location.origin;
const socketPath = process.env.REACT_APP_SOCKET_PATH || '/socket.io';
const forcePolling = process.env.REACT_APP_SOCKET_FORCE_POLLING === 'true';

export const socket = io(socketUrl, {
  path: socketPath,
  transports: forcePolling ? ['polling'] : ['websocket', 'polling'],
  upgrade: !forcePolling,
  withCredentials: true,
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
});
